(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vdb-setting-pdp"]) return;
  try {
    
        var loadProductRecommendationsIntoSection = function() {
        var section = document.querySelector(".product-recommendations");
        if (!section) return;

        var request = new XMLHttpRequest();
        request.open("GET", section.dataset.url);
        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
            var container = document.createElement("div");
            container.innerHTML = request.response;
            var newSection = container.querySelector(".product-recommendations");
            if (newSection) {
                section.innerHTML = newSection.innerHTML;
            }
            }
        };
        request.send();
        };

        document.addEventListener("shopify:section:load", function(event) {
        if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
            loadProductRecommendationsIntoSection();
        }
        });

        loadProductRecommendationsIntoSection();
        
  } catch(e) { console.error(e); }
})();
})();
